<template>
  <v-app ref="page-top">
    <v-btn
      color="orange"
      :fab="true"
      fixed
      right
      top
      @click.stop="drawer = !drawer"
    >
      <v-icon color="white">menu</v-icon>
    </v-btn>

    <v-navigation-drawer app v-model="drawer" right temporary>
      <v-list nav dense>
        <v-list-item-group active-class="deep-orange--text text--accent-4">
          <v-list-item to="/">
            <v-list-item-title>
              <v-icon class="mr-2">home</v-icon> Home
            </v-list-item-title>
          </v-list-item>

          <v-list-item to="/gallery">
            <v-list-item-title>
              <v-icon class="mr-2">photo_library</v-icon> Gallery
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <router-view></router-view>
    </v-main>

    <v-btn :fab="true" color="orange" fixed right bottom @click="scrollToTop()">
      <v-icon color="white">keyboard_arrow_up</v-icon>
    </v-btn>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      drawer: false,
    };
  },
  methods: {
    scrollToTop() {
      this.$vuetify.goTo(this.$refs["page-top"], this.scrollOptions);
    },
  },
};
</script>
